import React from 'react';
import { Breakpoint, ControlLink, Text, Stack } from '@moda/om';
import { titleize } from '@moda/portal-stanchions';
import { OrderItem, OrderItemStatusGroup } from '../../../hooks/useOrder';
import { useIsFineJewelryReturnPolicyCovered } from '../../../hooks/useIsFineJewelryReturnPolicyCovered';
import { AccountOrderItemDetailsReturnSection } from '../AccountOrderItemDetailsReturnSection';
import { FineJewelryReturnMessage } from '../FineJewelryReturnMessage';

import './AccountOrderItemDetailsDesktop.scss';

interface Props {
  hasFineJewelry?: boolean;
  item?: OrderItem;
  orderNumber?: string;
  shouldHideCustomJewelryMessage?: boolean;
  showReturn?: boolean;
  showShippingStatus?: boolean;
  showTrack?: boolean;
}

export const AccountOrderItemDetailsDesktop: React.FC<Props> = ({
  hasFineJewelry,
  item,
  orderNumber,
  shouldHideCustomJewelryMessage,
  showReturn = false,
  showShippingStatus = true,
  showTrack = false
}) => {
  const isFineJewelryReturnPolicyCovered = useIsFineJewelryReturnPolicyCovered(item);

  if (!item) return null;

  return (
    <Breakpoint gt="sm">
      <Stack space={1} className="AccountOrderItemDetailsDesktop__status-container">
        {showShippingStatus && (
          <section className="AccountOrderItemDetailsDesktop__status">
            {item.attributes.shippingStatus && (
              <Stack space={1}>
                <Text treatment="body2" color="cement">
                  Status
                </Text>

                <Text treatment="body2" color="ink">
                  {typeof item.attributes.shippingStatus === 'string'
                    ? item.attributes.shippingStatus
                    : titleize(item.attributes.status)}
                </Text>
              </Stack>
            )}
          </section>
        )}
        {showTrack && item.attributes.shipmentTrackingUrl && (
          <section className="AccountOrderItemDetailsDesktop__tracking">
            <ControlLink
              href={item.attributes.shipmentTrackingUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Text treatment="body2" color="ink">
                {item?.attributes?.statusGroup === 'Returned' ? 'Track Return' : 'Track Shipment'}
              </Text>
            </ControlLink>
          </section>
        )}

        {showReturn && !hasFineJewelry ? (
          <AccountOrderItemDetailsReturnSection
            isReturnable={item.attributes.isReturnable}
            orderNumber={orderNumber}
            returnPolicy={item.attributes.returnPolicy}
            statusGroup={item.attributes.statusGroup}
          />
        ) : null}

        {hasFineJewelry &&
          item.attributes.statusGroup === OrderItemStatusGroup.Shipped &&
          item.attributes.isReturnable &&
          !shouldHideCustomJewelryMessage &&
          isFineJewelryReturnPolicyCovered && (
            <FineJewelryReturnMessage className="AccountOrderItemDetailsDesktop__fine-jewelry-message" />
          )}
      </Stack>
    </Breakpoint>
  );
};
